/**
 * Entry point for the React app — sets up the root element, the global portal
 * state provider, the router, and the toaster. Included from `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import "./index.css";
import "@/lib/firebase"; // initialize the Firebase SDK (auth + App Check) at startup
import { PortalProvider } from "@/features/portal/portal-context";
import { Toaster } from "@/components/ui/sonner";
import { routes } from "@/router";

const router = createBrowserRouter(routes);
const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <PortalProvider>
      <RouterProvider router={router} />
      <Toaster />
    </PortalProvider>
  </StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);
